/* eslint-disable no-use-before-define, react/require-default-props, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import { FC } from 'react';
import { ClearRefinements, useClearRefinements } from 'react-instantsearch-hooks-web';

type ResetFiltersProps = {
  containerClassName?: string;
};

export const ResetFilters: FC<ResetFiltersProps> = ({ containerClassName }) => {
  const { refine: clearRefinements } = useClearRefinements({ excludedAttributes: ['collections'] });

  if (containerClassName) {
    return (
      <div className={containerClassName} onClick={clearRefinements}>
        <ClearRefinements translations={{ resetButtonText: theme.locales.resetFilters }} />
      </div>
    );
  }

  return (
    <ClearRefinements
      translations={{ resetButtonText: theme.locales.resetFilters }}
      onClickCapture={clearRefinements}
      style={{ display: 'inline-block' }}
    />
  );
};
